import pjson from "../../package.json";
//export const URL_BASE = process.env.URL_BASE;

export const ver = pjson.version;
export const nameProject = pjson.name;

export const { ambiente } = window["runConfig"];
export const { URL_BASE } = window["runConfig"];

const { URL_GNP_CONN } = window["runConfig"];
export const URL_GNP_CONN_SERVICIOS = `${URL_GNP_CONN}/api/Servicio`;

export const { URL_HDI } = window["runConfig"];
export const { URL_QUALITAS } = window["runConfig"];

export const URL_BASE_POLIZARIO = "https://polizario3.backend.escotel.mx/api";
export const URL_BASE_POLIZARIO_QUALITAS = URL_QUALITAS;

export const elAguilaID = "ve7SE85lpL";

export const URL_UTILIDADES = "https://utilidades.escotel.mx/api";
export const URL_DEV_UTILIDADES = "https://dev-utilidades.escotel.mx/api";

export const URL_BASE_VER = `${URL_BASE}/api/Ver`;
export const URL_BASE_SMS = `${URL_BASE}/api/SMS`;
export const URL_NOTIFICACIONES_WA = `${URL_BASE}/api/Notificaciones`;
export const URL_NOTIFICACIONES_SMS = `${URL_BASE}/api/Notificaciones/EnviarMensajeTexto`;
export const URL_SOLICITUD_NOTIFICACIONES_ASISTENCIA_WA = `${URL_BASE}/api/Notificaciones/SolicitudNotificacionesAsistenciaWA`;
export const URL_GET_ACEPTACION_NOTIFICACION = `${URL_BASE}/api/Cabina/GetAceptacionNotificacion`;

export const URL_ACTIONS_GNP = `${URL_BASE}/api/GnpActions`;

export const URL_LOGIN = `${URL_BASE}/api/auth/login`;

export const URL_BASE_CLIENTES = `${URL_BASE}/api/clientes`;
export const URL_BASE_ASISTENCIAS = `${URL_BASE}/api/asistencias`;

export const URL_BASE_ALLOWEDBROWSER = `${URL_BASE}/api/AllowedBrowser`;

export const URL_BASE_PROVEEDORES = `${URL_BASE}/api/proveedores`;

export const URL_BASE_HDI = URL_HDI;

export const URL_PROVEEDORES_ACTIVOS = `${URL_BASE}/api/cabina/GetProveedoresActivos`;
export const URL_MATERIALES_POR_CAMPANIA = `${URL_BASE}/api/Cabina/MaterialesPorCampania`;

export const QUALITAS_URL = "https://siica.qualitas.com.mx/AAQ-WS/webservices";

export const URL_BASE_EscalamientoElAguila = `${URL_BASE}/api/EscalamientoElAguila`;

export const URL_ELAGUILA_ACTIONS = `${URL_BASE}/api/ElAguilaActions`;

export const URL_CABINA_ASIGNACION = `${URL_BASE}/api/CabinaAsignacion`;
export const URL_CABINA_USUARIO_ASIGNACION = `${URL_BASE}/api/CabinaUsuarioAsignacion`;
export const URL_ASISTENCIA_INCIDENCIA = `${URL_BASE}/api/AsistenciaIncidencia`;
export const URL_ACTIVIDADES_SEGUIMIENTO = `${URL_BASE}/api/ActividadesSeguimiento`;
export const URL_ASISTENCIA_DESTINO = `${URL_BASE}/api/AsistenciaDestino`;

export const URL_SERVICIOS_PROPUESTOS = `${URL_BASE}/api/ServiciosPropuestos`;
export const URL_PROVEEDORES_ACTIVOS2 = `${URL_BASE}/api/ProveedoresActivos`;

export const URL_BASE_ESCALAMIENTO_ASIGNACION = `${URL_BASE}/api/EscalamientoAsignacion`;

export const URL_REPORTE_DANOS_PROVEEDOR = `${URL_BASE}/api/ReporteDanosProveedor`;

const { URL_GSEGUROS } = window["runConfig"];
export const URL_GSEGUROS_DATOS = `${URL_GSEGUROS}/api/GS/GetDatos`;
export const URL_GSEGUROS_EMISION = `${URL_GSEGUROS}/api/GS/emision/`;
export const URL_EDEGA_VALIDAR_CONTRATO = `${URL_GSEGUROS}/api/Edega/validarcontrato`;
export const URL_EDEGA_DETALLE_RECLAMO = `${URL_GSEGUROS}/api/Edega/detalleReclamo`;
export const URL_EDEGA_ENVIAR_DOCUMENTO = `${URL_BASE}/api/Edega/EnviarDocumento`;

export const URL_PROVEEDOR_API = `${URL_BASE}/api/proveedorApi`;

export const URL_MAPBOX_GEOCODING = "https://api.mapbox.com/geocoding/v5/mapbox.places";
export const URL_MAPBOX_DIRECTIONS = "https://api.mapbox.com/directions/v5/mapbox";

export const URL_BASE_REEMBOLSOS = `${URL_BASE}/api/Reembolsos`
